import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template imports
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

export const AccordionStyled = styled(Accordion)`
  ${({ theme }) => {
    return css`
      #container-who-we-are-custom-accolades-numbers-we-like-to-share {
        background-color: ${theme.colors.neutral.white};
        border: none;
      }
    `;
  }}
`;

export const BulletedListStyled = styled(BulletedList)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      columns: ${mediumUp ? 2 : 1 };
      li {
        padding-right: ${mediumUp ? rem(40) : 0 };
      }
    `;
  }}
`;

export const DivStyledBulletedListContainerDesktop = styled.div`
  ${({ theme }) => {
    const mediumDown = theme.mediumDown();
    return css`
      ${mediumDown && 'display: none;'};
    `;
  }}
`;

export const DivStyledBulletedListContainerMobile = styled.div`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      ${mediumUp && 'display: none;'};
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      ${mediumUp && `padding-bottom: ${rem(44)}`};
    `;
  }
}`;

export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    return css`
      color: ${theme.colors.neutral.grayDark2};
    `;
  }
}`;

